import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { PalettePackage, PaletteProduct } from "@/types/api/api-types";

const InformationDisplay = ({
  label,
  value,
  bold,
}: {
  label: string;
  value: string;
  bold?: boolean;
}) => {
  return (
    <div className="items-top flex flex-row gap-2">
      <p className={cn("w-fit min-w-fit text-sm text-gray-900", bold && "font-bold")}>{label} :</p>
      <p className={cn("text-sm text-gray-900", bold && "font-bold")}>{value}</p>
    </div>
  );
};

export const PaletteProductInfo = ({
  paletteProduct,
  index,
}: {
  paletteProduct: PaletteProduct;
  index: number;
}) => {
  const { t } = useTranslation("boQuotations");
  return (
    <InformationDisplay
      label={t("quoteProducts.productLabel", { number: index + 1 })}
      value={t("quoteProducts.bottles", {
        quantity: paletteProduct.bottleQuantity,
        volume: paletteProduct.volume,
      })}
      key={`palette-product-${index}`}
    />
  );
};

export const PalettePackageInfo = ({
  palettePackage,
  index,
}: {
  palettePackage: PalettePackage;
  index: number;
}) => {
  const { t } = useTranslation("boQuotations");
  return (
    <>
      <InformationDisplay
        label={t("quoteProducts.paletteLabel", { number: index + 1 })}
        value={t("quoteProducts.dimensions", {
          length: palettePackage.length,
          width: palettePackage.width,
          height: palettePackage.height,
          weight: palettePackage.weight,
        })}
        key={`palette-package-${index}`}
      />
      <InformationDisplay
        label={t("quoteProducts.paletteLabel", { number: index + 1 })}
        value={`${palettePackage.value} €`}
        key={`palette-package-value-${index}`}
      />
    </>
  );
};
